.cg{z-index:2;}